import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  align-items: center;

  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  span {
    display: flex;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
  }
  svg {
    margin-left: 8px;
  }
`
